import { Container, Row, Col } from "react-bootstrap";
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon2 from "../assets/img/nav-icon2.svg";

export const Footer = () => {
    return (
        <footer className="footer">
            <Container>
                <Row className="align-items-center">
                    <Col size={12} xl={9} sm={8} xs={8}>
                        <h1>NSD</h1>
                        <p>Copyright 2024 | All Rights Reserved</p>
                        <p>Made in React</p>
                    </Col>
                    <Col size={12} xl={3} sm={4} xs={4} className="text-center text-sm-end"> {/* to hide picture */}
                        <div className="social-icon">
                            <a href="https://www.linkedin.com/in/nicolasrubioh/" target="_blank" rel="noopener noreferrer"> <img src={navIcon1} alt="Icon" /></a>
                            <a href="https://github.com/nrubioh" target="_blank" rel="noopener noreferrer"> <img src={navIcon2} alt="Icon" /></a>
                        </div>
                    </Col>
                </Row>
            </Container>
        </footer>
    )
}